<template>
  <div class="page-title">
    {{ title }}
  </div>
</template>

<script>
export default {
props:['title']
}
</script>

<style lang="less" scoped>
.page-title{
  font-size: 25px;
  font-weight: bold;
  margin-bottom: 20px;
}

</style>